import { Navigate, Route, Routes } from 'react-router';
import Sidebar from './Sidebar';
import UserThumbnail from './UserThumbnail';
import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SystemSettings from './SystemSettings';
import PasswordEditor from './PasswordEditor';
import ProfileEditor from './ProfileEditor';


export default class Portal extends React.Component {
   
   state = {
      sidebarOpen: false,
      systemSettingsModalOpen: false,
      passwordEditorOpen: false,
      profileEditorOpen: false,
   }

   openSystemSettings = () => {
      this.setState({ systemSettingsModalOpen: true });
   }

   closeSystemSettings = () => {
      this.setState({ systemSettingsModalOpen: false });
   }

   openPasswordEditor = async () => {
      this.setState({ passwordEditorOpen: true });
   }

   closePasswordEditor = () => {
      this.setState({ passwordEditorOpen: false });
   }

   openProfileEditor = async () => {
      this.setState({ profileEditorOpen: true });
   }

   closeProfileEditor = () => {
      this.setState({ profileEditorOpen: false });
   }

   render() {
      const { sidebarOpen } = this.state;
      const { user, title="Portal", defaultPath } = this.props;
      let { sidebarItems, routes } = this.props;

      if (!sidebarItems) {
         sidebarItems = [
            {
               caption: 'Dashboard',
               icon: DashboardIcon,
               path: '/',
            }
         ];
      }

      if (!routes) {
         routes = [
            {
               path: '/',
               element: <div className='h-full flex justify-center items-center'>
                  <div className='text-xl text-gray-500 text-center'>
                     Nothing here yet.
                  </div>
               </div>
            }
         ];
      }

      const sidebar = <Sidebar
         openPasswordEditor={this.openPasswordEditor}
         openProfileEditor={this.openProfileEditor}
         openSystemSettings={this.openSystemSettings}
         user={user}
         items={sidebarItems}
         onClose={() => this.setState({ sidebarOpen: false })}
      />;

      let mobileSidebar;

      if (sidebarOpen) {
         mobileSidebar = <div className='fixed top-0 left-0 h-screen w-screen z-[5000] md:hidden'>
            {sidebar}
         </div>
      }

      return <>
         <div className='page-height md:grid grid-cols-[auto,1fr]'>
            <div className='hidden md:block'>
               {sidebar}
            </div>

            {mobileSidebar}

            <div className='h-full overflow-hidden grid grid-rows-[auto,1fr] p-2 z-30'>
               <div className='py-3 relative border-b-[1px] border-b-[#ccc]'>
                  <div className='grid grid-cols-[1fr,auto]'>
                     <div className='text-gray-500 text-2xl font-bold uppercase flex items-center px-4'>
                        {title}
                     </div>
                     <div className='hidden md:grid'>
                        <UserThumbnail />
                     </div>
                     <div className='md:hidden'>
                        <IconButton onClick={() => this.setState({ sidebarOpen: true })}>
                           <MenuIcon />
                        </IconButton>
                     </div>
                  </div>
               </div>
               <div className='overflow-y-auto'>
                  <Routes>
                     {
                        defaultPath && <Route
                           path='/'
                           element={<Navigate replace to={`/dashboard${defaultPath}`} />}
                        />
                     }
                     {
                        routes.map((route, i) => {
                           return <Route
                              key={i}
                              path={route.path}
                              element={route.element}
                           />
                        })
                     }
                  </Routes>
               </div>
            </div>
         </div>
         {
            this.state.systemSettingsModalOpen && <SystemSettings
               onClose={this.closeSystemSettings}
            />
         }
         {
            this.state.passwordEditorOpen && <PasswordEditor
               onClose={this.closePasswordEditor}
            />
         }
         {
            this.state.profileEditorOpen && <ProfileEditor
               onClose={this.closeProfileEditor}
            />
         }
      </>;
   }
}